(function () {
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  document.addEventListener('DOMContentLoaded', function () {
    // ---- gallery ----
    var imgs = qa('.shop-main-image'), thumbs = qa('.shop-thumbnail'), dots = qa('.shop-indicator-dot');
    var idx = 0;
    function show(n) {
      if (!imgs.length) return;
      idx = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, i) { im.classList.toggle('active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      var prev = q('.shop-prev-arrow'), next = q('.shop-next-arrow');
      if (prev) prev.classList.toggle('disabled', idx === 0);
      if (next) next.classList.toggle('disabled', idx === imgs.length - 1);
      if (thumbs[idx] && thumbs[idx].scrollIntoView) thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'center' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.index); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.dataset.index); }); });
    qa('.shop-nav-arrow').forEach(function (a) {
      a.addEventListener('click', function () { show(idx + (+a.dataset.dir)); });
    });

    // ---- accordion ----
    qa('.faq-question').forEach(function (h) {
      h.addEventListener('click', function () { h.parentNode.classList.toggle('open'); });
    });

    // ---- lazy-load video data only when near the viewport ----
    var lazyVids = qa('.wst-inline-video');
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.preload = 'metadata'; e.target.load(); vio.unobserve(e.target); } });
      }, { rootMargin: '400px' });
      lazyVids.forEach(function (v) { vio.observe(v); });
    } else { lazyVids.forEach(function (v) { v.preload = 'metadata'; v.load(); }); }

    // ---- inline video (plays inside the frame) ----
    qa('.video-thumbnail').forEach(function (t) {
      var btn = q('.play-button', t), v = q('video', t);
      if (!btn || !v) return;
      function stop(o) { o.pause(); if (o.parentNode) o.parentNode.classList.remove('playing'); }
      function play() {
        qa('.video-thumbnail video').forEach(function (o) { if (o !== v) stop(o); });
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
        t.classList.add('playing');
      }
      btn.addEventListener('click', function (e) { e.preventDefault(); play(); });
      v.addEventListener('click', function () { if (v.paused) { play(); } else { stop(v); } });
    });

    // ---- size chart modal ----
    var sizeBtn = q('#WstSizeBtn'), sizeModal = q('#WstSizeModal');
    if (sizeBtn && sizeModal) {
      sizeBtn.addEventListener('click', function () { sizeModal.hidden = false; });
      q('.sbz-close', sizeModal).addEventListener('click', function () { sizeModal.hidden = true; });
      sizeModal.addEventListener('click', function (e) { if (e.target === sizeModal) sizeModal.hidden = true; });
    }

    // ---- variants ----
    var form = q('#WstProductForm'), data = q('#WstProductJSON');
    if (form && data) {
      var product = JSON.parse(data.textContent);
      var idInput = q('#WstVariantId'), atc = q('#WstAtc'), atcText = q('#WstAtcText');
      var price = q('#WstPrice'), compare = q('#WstCompare');
      var dec = function (s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; };
      function selectedOptions() {
        return qa('.simple-variant-picker__option', form).map(function (o) {
          var c = q('input:checked', o); return c ? c.value : null;
        });
      }
      function sync() {
        var opts = selectedOptions();
        qa('.simple-variant-picker__option', form).forEach(function (o, i) {
          var lab = q('.simple-variant-picker__selected-variant', o); if (lab) lab.textContent = opts[i] || '';
        });
        var v = opts.length ? product.variants.find(function (x) {
          return x.options.every(function (val, i) { return val === opts[i]; });
        }) : product.variants[0];
        if (!v) { atc.disabled = true; return; }
        idInput.value = v.id;
        atc.disabled = !v.available;
        var p = window.wstPrices && window.wstPrices[v.id];
        if (p) {
          if (price) price.textContent = dec(p.price);
          if (compare) compare.textContent = dec(p.compare);
          atcText.innerHTML = v.available
            ? atc.dataset.label + ' - ' + dec(p.price) + (p.compare ? ' <span class="compare-price">(' + dec(p.compare) + ')</span>' : '')
            : atc.dataset.soldout;
        }
        // swap gallery to variant image if it exists
        if (v.featured_media && v.featured_media.position) show(v.featured_media.position - 1);
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      form.addEventListener('change', sync);
      sync();
    }
  });
})();
(function(){var c=document.querySelector('.shop-image-container');if(!c)return;var x0=null,y0=null;c.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});c.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;x0=null;if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy))return;var b=document.querySelector(dx<0?'.shop-next-arrow':'.shop-prev-arrow');if(b&&!b.classList.contains('disabled'))b.click();},{passive:true});})();

;(function () {
  var root = document.getElementById('WstBundle'); if (!root) return;
  var qtyInput = document.getElementById('WstQty'), priceEl = document.getElementById('WstPrice');
  var atc = document.getElementById('WstAtc'), atcText = document.getElementById('WstAtcText');
  var opts = Array.prototype.slice.call(root.querySelectorAll('.wst-bundle__opt'));
  var label = atc ? (atc.getAttribute('data-label') || 'ADD TO CART') : 'ADD TO CART';
  var selected = 3, busy = false, expired = false;
  var form = document.getElementById('WstProductForm'), prod = null;
  try { prod = JSON.parse(document.getElementById('WstProductJSON').textContent); } catch (e) {}
  var ci = -1, si = -1, colours = [], sizes = [], rows = [], touched = [];
  var SA = { 'XS': '30', 'S': '32', 'M': '34', 'L': '36', 'XL': '38', '2XL': '40', '3XL': '42' }, KG = { 'S': 'Under 50kg', 'M': '50-60kg', 'L': '60-70kg', 'XL': '70-80kg', '2XL': '80-90kg', '3XL': '90-100kg' };
  var HEX = { 'liquorice': '#1f1f23', 'pine': '#2e6b5b', 'blueberry': '#2f80d1', 'brown sugar': '#7a4636', 'oyster blue': '#5f6f7d', 'gold mocha': '#8a6f55', 'black truffle': '#4a2f2b', 'black': '#111111', 'light brown': '#cfa98a', 'brown': '#7b4b36' };
  if (prod && prod.variants) {
    (prod.options || []).forEach(function (o, i) { var n = String(o && o.name || o); if (/colou?r|shade/i.test(n)) ci = i; else if (/size/i.test(n)) si = i; });
    prod.variants.forEach(function (v) { var c = ci > -1 ? v.options[ci] : null, z = si > -1 ? v.options[si] : null; if (c && colours.indexOf(c) < 0) colours.push(c); if (z && sizes.indexOf(z) < 0) sizes.push(z); if (si < 0 && sizes.indexOf('') < 0) sizes.push(''); });
  }
  var box = document.createElement('div'); box.className = 'wst-picks'; box.id = 'WstPicks';
  function findV(c, z) { return prod.variants.filter(function (v) { return v.options[ci] === c && (si < 0 || v.options[si] === z); })[0]; }
  function checked(cls) { var i = form && form.querySelector(cls + ' input:checked'); return i ? i.value : null; }
  function fix(r) { var v = findV(r.c, r.s); if (!v || !v.available) { for (var k = 0; k < sizes.length; k++) { var w = findV(r.c, sizes[k]); if (w && w.available) { r.s = sizes[k]; break; } } } }
  function fillRows(q) {
    while (rows.length < q) { var last = rows[rows.length - 1]; var r = last ? { c: last.c, s: last.s } : { c: checked('.option--color') || colours[0], s: checked('.option--size') || sizes[0] }; fix(r); rows.push(r); touched.push(false); }
    rows.length = q; touched.length = q;
  }
  function drawPicks() {
    var h = '<div class="wst-picks__h">' + (si < 0 ? (rows.length > 1 ? 'Pick your shade for each' : 'Pick your shade') : (rows.length > 1 ? 'Pick colour &amp; size for each' : 'Pick your colour &amp; size')) + '</div>';
    rows.forEach(function (r, i) {
      var dots = colours.map(function (c) { return '<button type="button" class="wst-dot' + (c === r.c ? ' is-on' : '') + '" data-i="' + i + '" data-c="' + c + '" title="' + c + '" aria-label="' + c + '" style="background:' + (HEX[c.toLowerCase()] || '#cccccc') + '"></button>'; }).join('');
      var sel = sizes.map(function (z) { var v = findV(r.c, z), ok = v && v.available; return '<option value="' + z + '"' + (z === r.s ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + z + (SA[z] ? ' \u00b7 SA ' + SA[z] : '') + (ok ? '' : ' (sold out)') + '</option>'; }).join('');
      h += '<div class="wst-pick"><span class="wst-pick__n">#' + (i + 1) + '</span><span class="wst-pick__dots">' + dots + '</span>' + (si < 0 ? '<span class="wst-pick__shade">' + r.c + '</span>' : '<select class="wst-pick__size" data-i="' + i + '" aria-label="Size for item ' + (i + 1) + '">' + sel + '</select>') + '' + (KG[r.s] ? '<span class="wst-pick__hint">' + r.s + ' fits ' + KG[r.s] + '</span>' : '') + '</div>';
    });
    box.innerHTML = h;
  }
  function edit(i, key, val) {
    rows[i][key] = val; fix(rows[i]); touched[i] = true;
    if (i === 0) rows.forEach(function (r, j) { if (j > 0 && !touched[j]) { r.c = rows[0].c; r.s = rows[0].s; fix(r); } });
    drawPicks();
  }
  box.addEventListener('click', function (e) { var d = e.target.closest ? e.target.closest('.wst-dot') : null; if (d) { e.preventDefault(); e.stopPropagation(); edit(+d.getAttribute('data-i'), 'c', d.getAttribute('data-c')); } });
  box.addEventListener('change', function (e) { var z = e.target; if (z && z.className === 'wst-pick__size') { e.stopPropagation(); edit(+z.getAttribute('data-i'), 's', z.value); } });
  function picks() {
    var on = !expired && prod && colours.length && sizes.length;
    if (form) form.classList.toggle('wst-multi', !!on);
    if (!on) { if (box.parentNode) box.parentNode.removeChild(box); return; }
    var host = root.querySelector('.wst-bundle__opt.is-selected'); if (!host) return;
    fillRows(selected);
    if (host.nextSibling !== box) host.parentNode.insertBefore(box, host.nextSibling);
    drawPicks();
  }
  window.wstMultiItems = function () {
    if (expired || !rows.length || !prod) return null;
    var m = {}, out = [];
    rows.forEach(function (r) { var v = findV(r.c, r.s); if (!v) return; if (m[v.id]) m[v.id].quantity++; else { m[v.id] = { id: v.id, quantity: 1 }; out.push(m[v.id]); } });
    return out.length ? out : null;
  };

  function parse() {
    var t = (priceEl && priceEl.textContent || '').trim();
    var num = parseFloat(t.replace(/[^\d.,]/g, '').replace(/,(\d{2})$/, '.$1').replace(/,/g, ''));
    var pre = (t.match(/^\D*/) || [''])[0];
    return { n: num, pre: pre };
  }
  function fmt(p, n) { return p + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function render() {
    var u = parse(); if (!(u.n > 0)) return;
    var cmp = parseFloat(root.getAttribute('data-compare')) || 0; if (cmp < u.n) cmp = u.n;
    opts.forEach(function (o) {
      var q = +o.getAttribute('data-qty'), pay = +o.getAttribute('data-pay');
      var fx = parseFloat(root.getAttribute('data-fix' + q)) || 0; var total = fx > 0 ? fx : u.n * pay, was = cmp * q;
      var set = function (r, v) { var e = o.querySelector('[data-role=' + r + ']'); if (e) e.textContent = v; };
      set('now', fmt(u.pre, total));
      set('was', was > total + 0.001 ? fmt(u.pre, was) : '');
      set('save', was > total + 0.001 ? 'Save ' + fmt(u.pre, was - total) : '');
      if (q > 1) set('each', fmt(u.pre, total / q) + ' each');
      o.classList.toggle('is-selected', q === selected);
      var r = o.querySelector('input'); if (r) r.checked = (q === selected);
    });
    if (qtyInput) qtyInput.value = selected;
    setAtc();
    picks();
  }
  function setAtc() {
    if (!atcText || !atc || atc.disabled) return;
    var u = parse(); if (!(u.n > 0)) return;
    var pay = selected === 3 ? 2 : selected === 5 ? 3 : 1;
    var fxs = parseFloat(root.getAttribute('data-fix' + selected)) || 0; var txt = label + ' - ' + fmt(u.pre, fxs > 0 ? fxs : u.n * pay);
    if (atcText.textContent !== txt) { mo.disconnect(); atcText.textContent = txt; observe(); }
  }
  var mo = new MutationObserver(function () { if (!busy) { busy = true; render(); busy = false; } });
  function observe() { if (priceEl) mo.observe(priceEl, { childList: true, characterData: true, subtree: true }); if (atcText) mo.observe(atcText, { childList: true, characterData: true, subtree: true }); }
  opts.forEach(function (o) { o.addEventListener('click', function (e) { e.preventDefault(); selected = +o.getAttribute('data-qty'); render(); }); });
  observe(); render();
  // personal offer window: each visitor gets roughly 14 hours, then the bundle price is gone for them
  var KEY = 'wstBundleEnd', end = 0;
  try { end = +localStorage.getItem(KEY) || 0; } catch (e) {}
  if (!end) {
    var rem = 14 * 3600 - (1 + Math.floor(Math.random() * 58)) * 60 - Math.floor(Math.random() * 60);
    end = Date.now() + rem * 1000;
    try { localStorage.setItem(KEY, String(end)); } catch (e) {}
  }
  var clock = document.getElementById('WstBundleClock');
  function expire() { expired = true; root.style.display = 'none'; selected = 1; render(); }
  function tick() {
    var left = Math.floor((end - Date.now()) / 1000);
    if (left <= 0) { expire(); return false; }
    var h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    var p = function (x) { return (x < 10 ? '0' : '') + x; };
    if (clock) clock.textContent = p(h) + ':' + p(m) + ':' + p(s);
    return true;
  }
  if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
})();
